import {DateTime} from 'luxon';

export type PeriodDefaultLength = 'this_month' | 'last_month' | 'this_and_last_month' | 'last_7_days';

export const getFirstDayBasedOnParameter = (dateObject: DateTime, periodDefaultLength: PeriodDefaultLength): DateTime => {
    if (periodDefaultLength === 'this_and_last_month' || periodDefaultLength === 'last_month') {
        return dateObject.minus({months: 1}).startOf('month');
    } else if (periodDefaultLength === 'this_month') {
        return dateObject.startOf('month');
    } else {
        return dateObject.minus({days: 6}).startOf('day');
    }
};

export const getEndDateBasedOnParameter = (dateObject: DateTime, periodDefaultLength: PeriodDefaultLength): DateTime => {
    if (periodDefaultLength === 'last_month') {
        return dateObject.minus({months: 1}).endOf('month');
    } else {
        return dateObject.endOf('day');
    }
};

export const getDefaultDateRange = (periodDefaultLength: PeriodDefaultLength): { startDate: string; endDate: string } => {
    const today = DateTime.now();
    const startDate = getFirstDayBasedOnParameter(today, periodDefaultLength);
    const endDate = getEndDateBasedOnParameter(today, periodDefaultLength);
    
    return {
        startDate: startDate.toFormat('dd/MM/yyyy'),
        endDate: endDate.toFormat('dd/MM/yyyy')
    };
};
